import RlHeaderLogo from "../header/RlHeaderLogo";

const LoginLogo = ({ appDescription }: { appDescription: string }) => (
  <RlHeaderLogo
    productName={appDescription}
    longLogo
    width="350px"
    linksReloadDocument
  />
);

export default LoginLogo;
